var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotif(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 464,
    height: 512,
    viewBox: "0 0 464 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30_463)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M404 427.1H59.5004C36.7004 427.1 16.2004 414.4 6.20041 393.9C-3.89959 373.4 -1.39959 349.5 12.5004 331.4C23.6004 317.1 29.7004 299.2 29.7004 281.1V202.3C29.6004 90.7 120.4 0 231.9 0C343.4 0 434.1 90.7 434.1 202.2V281.3C434.1 299.2 440.1 317 451 331.3L451.2 331.6C465 349.7 467.3 373.6 457.2 394C447.1 414.4 426.7 427.1 404 427.1ZM231.9 40C142.5 40 69.7004 112.8 69.7004 202.2V281C69.7004 307.9 60.6004 334.5 44.2004 355.8C39.6004 361.8 38.8004 369.4 42.1004 376.2C45.4004 383 51.9004 387 59.5004 387H404.1C411.6 387 418.1 383 421.5 376.2C424.8 369.4 424.1 361.8 419.5 355.8L419.3 355.5C403.1 334.3 394.2 308 394.2 281.3V202.2C394.2 112.8 321.4 40 232 40H231.9ZM280.1 512H183.3C172.3 512 163.3 503 163.3 492C163.3 481 172.3 472 183.3 472H280.1C291.1 472 300.1 481 300.1 492C300.1 503 291.1 512 280.1 512Z",
    fill: "#1F1F1F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30_463"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 463.5,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotif);
export default __webpack_public_path__ + "static/media/notif.4f8c8d316c3b49117cd89503f5e38d6a.svg";
export { ForwardRef as ReactComponent };